import Index from './index.vue'
import Dashboard from './views/Dashboard.vue'
import Profile from './views/Profile.vue'
import Search from './views/Search.vue'

export default [
  {
    path: '/organization',
    name: 'organization',
    component: Index,
    title: 'organization',
    redirect: { name: 'organization-dashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'organization-dashboard',
        component: Dashboard,
      },
      {
        path: 'search',
        name: 'search-organization',
        component: Search,
      },
      {
        path: 'profile/:id',
        name: 'organization-profile',
        component: Profile,
        props: true,
      },
    ],
  },
]
